import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import loadingAnimation from "../../assets/animations/loading.json";

export default function Loader({ text = "Loading..." }: { text?: string }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        minHeight: "calc(100vh - 200px)",
        textAlign: "center",
        color: "#666",
      }}
    >
      <DotLottieReact
        data={loadingAnimation}
        loop
        autoplay
        speed={2}
        style={{ width: "74px", height: "74px" }}
      />
      <p style={{ margin: 0 }}>{text}</p>

      <style>
        {`
          .dotlottie-container {
            width: 100px;
            height: 100px;
            margin: 0 auto;
          }
        `}
      </style>
    </div>
  );
}
